import * as React from 'react';
import Radio from '@mui/material/Radio';

interface ColorRadioButtonsProps {
  isActive: boolean;
  handleClick: () => void;
  item: string;
}

const RadioButton: React.FC<ColorRadioButtonsProps> = ({ isActive, handleClick, item }) => {
 

  const controlProps = (item: string) => ({
    checked: isActive,
    onClick: () => handleClick(),
    value: item,
    name: 'color-radio-button-demo',
  });

  return (
    <div>
     <Radio
          {...controlProps(item)}
          color="default"
          sx={{
            color: isActive ? "#FB7672" : "black",
            '&.Mui-checked': {
              color: "#FB7672",
            },
          }}
        />
    </div>
  );
};

export default RadioButton;
